import { FETCH_SPONSORED_BRANDS } from '../actions/sponsoredBrands';
import asyncReducer from '../helpers/asyncReducer';

const initialState = {
  sponsoredBrands: {},
  busy: false,
  lastFetched: null,
  error: null,
};

const mapFulfilledActionToState = (state, action) => ({
  sponsoredBrands: action.payload?.reduce(
    (accumulator, brand, index) => ({
      ...accumulator,
      [index]: brand,
    }),
    {},
  ),
});

const sponsoredBrands = (state = initialState, action) => (
  asyncReducer(state, action, FETCH_SPONSORED_BRANDS, mapFulfilledActionToState)
  || state
);

export default sponsoredBrands;
